// /Users/divasmishra/Desktop/fitness-tracker/src/Assests/company.png
import React, { useState } from "react";
import { Link } from "react-router-dom";
import CompanyLogo from '/Users/divasmishra/Desktop/fitness-tracker/src/Assests/company.png'; // Assuming Assets folder is at the same level as this component


export default function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={CompanyLogo} alt="Company Logo"/>
      </div>
      <div className={`menu-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
        <div className="menu-button">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
        <li><a href="#workout" className="btn">Workout Plans</a></li>
        <li><a href="#DietPlanner" className="btn">Diet Plans</a></li>
        <li><a href="#Bmi" className="btn">BMI Calculator</a></li>
        <li><a href="#contact" className="btn">Contact</a></li>
        <li><Link to="/login" className="btn login">Login</Link></li>
        <li><Link to="/signup" className="btn signup">Signup</Link></li>
      </ul>
    </nav>
  );
}
